import {useLocation} from "react-router-dom";
import {useMemo} from "react";

const useQueryParam = (paramName) => {

    const search = useLocation().search;
    return useMemo(() => {
        return new URLSearchParams(search).get(paramName)
    }, [search, paramName])
}

export default useQueryParam;